import { render, staticRenderFns } from "./ConsolidatedAccountingDetail.vue?vue&type=template&id=1a0ddbeb&scoped=true"
import script from "./ConsolidatedAccountingDetail.vue?vue&type=script&lang=js"
export * from "./ConsolidatedAccountingDetail.vue?vue&type=script&lang=js"
import style0 from "./ConsolidatedAccountingDetail.vue?vue&type=style&index=0&id=1a0ddbeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0ddbeb",
  null
  
)

export default component.exports